export default __webpack_public_path__ + "static/media/fishing.6ae35a50.svg";